import { clsx } from 'clsx';
import { CSSProperties } from 'react';
import { Switch } from 'react-aria-components';
import Text from '~/components/typographies/Text';
import CheckIcon from '~/icons/icon-check.svg?react';
import CloseIcon from '~/icons/icon-close.svg?react';
import styles from './Toggle.module.scss';

interface Props {
  bold?: boolean;
  className?: string;
  disabled?: boolean;
  label?: string;
  otherInfo?: string;
  style?: CSSProperties;
  isSelected: boolean;
  onChange: (value: boolean) => void;
  variant?: 'default' | 'custom';
}

const Toggle: React.FC<Props> = ({
  bold,
  className,
  disabled,
  style,
  isSelected,
  label,
  onChange,
  otherInfo,
  variant = 'default',
}) => {
  const computedContainerClassName = clsx(className, styles.container);
  const computedInnerClassName = clsx(className, styles.innerContainer, { [styles.custom!]: variant === 'custom' });

  return (
    <div className={computedContainerClassName} style={style}>
      <Switch isSelected={isSelected} onChange={onChange} className={computedInnerClassName} isDisabled={disabled}>
        <div className={styles.indicatorContainer}>
          <div className={styles.indicator}>
            {variant === 'custom' && !isSelected && <CloseIcon />}
            {variant === 'custom' && isSelected && <CheckIcon />}
          </div>
        </div>
        {label && (
          <Text variant="body2" weight={bold ? 'semibold' : 'regular'} secondaryColor={disabled}>
            {label}
          </Text>
        )}
      </Switch>
      {otherInfo && (
        <Text variant="caption" weight="medium" secondaryColor>
          {otherInfo}
        </Text>
      )}
    </div>
  );
};

export default Toggle;
